module.exports = __webpack_public_path__ + "img/icon-share.5dd55f16.svg";